import React, { useState } from "react";
import "./HastagGenerator.css";
import { Button } from "@mui/material";

const WeddingHashtagGenerator = () => {
  const [formData, setFormData] = useState({
    yourFirstName: "",
    yourLastName: "",
    yourNickname: "",
    partnerFirstName: "",
    partnerLastName: "",
    partnerNickname: "",
    weddingDate: "",
    weddingCity: "",
    weddingCategory: "",
  });

  const [hashtags, setHashtags] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  const hashtagsPerPage = 5;

  const nextTags = () => {
    if (startIndex + hashtagsPerPage < hashtags.length) {
      setStartIndex(startIndex + hashtagsPerPage);
    }
  };

  // Function to go to previous set of hashtags
  const prevTags = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - hashtagsPerPage);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const copyToClipboard = (tag) => {
    navigator.clipboard.writeText(tag);
    alert(`Copied: ${tag}`);
  };

  const generateHashtags = (e) => {
    e.preventDefault();
    const {
      yourFirstName,
      yourLastName,
      yourNickname,
      partnerFirstName,
      partnerLastName,
      partnerNickname,
      weddingDate,
      weddingCity,
      weddingCategory,
    } = formData;

    if (!yourFirstName || !partnerFirstName) {
      alert("Both names are required!");
      return;
    }

    console.log("Type of weddingDate:", typeof weddingDate); // Should be "string"

    const date = weddingDate ? weddingDate.split("-")[0] : "";
    console.log("Extracted Date Part:", date); // Should be "2025"

    const coupleMashup1 = `${yourFirstName.substring(
      0,
      3
    )}${partnerFirstName.substring(0, 3)}`;
    const coupleMashup2 = `${partnerFirstName.substring(
      0,
      3
    )}${yourFirstName.substring(0, 3)}`;

    const newHashtags = [
      `#${yourFirstName}Weds${partnerFirstName}2025`,
      `#${yourFirstName}And${partnerFirstName}Forever`,
      `#${yourFirstName}Hearts${partnerFirstName}`,
      `#${yourFirstName}SaysIDoTo${partnerFirstName}`,
      `#${yourFirstName}Loves${partnerFirstName}ToInfinity`,
      `#Forever${yourFirstName}And${partnerFirstName}`,
      `#${yourFirstName}${partnerFirstName}HappilyEverAfter`,
      `#${yourLastName}LoveStory`,
      `#${coupleMashup1}Soulmates`,
      `#${coupleMashup2}WeddingVibes`,
      `#${yourNickname}KiShaadi`,
      `#${partnerNickname}KiShaadi`,

      // Cultural & Festive Hashtags
      `#ShaadiMubarak${yourFirstName}And${partnerFirstName}`,
      `#BaaratFor${yourFirstName}And${partnerFirstName}`,
      `#DulhanDiaries${partnerFirstName}`,
      `#DulhaDiaries${yourFirstName}`,
      `#BandBaajaBaraat2025`,
      `#SangeetNightWith${yourFirstName}And${partnerFirstName}`,
      `#MehndiHaiRachneWali`,
      `#ShubhMangalSavdhan`,
      `#DilwaleDulhaniaLeGaye`,
      `#PyaarKaBandhan${yourFirstName}And${partnerFirstName}`,

      // Location-Based Hashtags
      `#DreamWeddingIn${weddingCity}`,
      `#Royal${weddingCategory}Affair`,
      `#The${yourLastName}ShaadiSaga`,
      `#BigFat${weddingCity}Shaadi`,
      `#DestinationShaadiIn${weddingCity}`,
      `#WedLockedIn${weddingCity}`,

      // Date Based Hastags
      `#ShaadiOn${date}`,
      `#WeddingBells${date}`,
      `#HappilyEverAfter${date}`,
      `#MrAndMrs${date}`,
      `#TheBigDay${date}`,
      `#ForeverStarts${date}`,
      `#${yourFirstName}Weds${partnerFirstName}${date}`,
      `#${yourLastName}Wedding${date}`,
      `#TyingTheKnot${date}`,
      `#TogetherSince${date}`,
      `#MadeForEachOther${date}`,
      `#LoveSealedOn${date}`,
      `#ShaadiMubarak${date}`,
      `#FairyTaleWedding${date}`,
      `#Soulmates${date}`,

      // Trendy & Fun Hashtags
      `#HitchedWith${yourFirstName}And${partnerFirstName}`,
      `#FromMissToMrs${partnerFirstName}`,
      `#TogetherForever${yourFirstName}And${partnerFirstName}`,
      `#TyingTheKnot${yourFirstName}And${partnerFirstName}`,
      `#MrAndMrs${partnerLastName}`,
      `#RishtonKaBandhan${yourFirstName}And${partnerFirstName}`,
      `#ThePerfectMatch${yourFirstName}And${partnerFirstName}`,
    ];
    setHashtags(newHashtags);
  };

  return (
    <div className="Hastagmain">
    <div className="Hastagcontainer">
      <h2> Wedding Hashtag Generator 💕</h2>
      <form onSubmit={generateHashtags} className="form">
        <div className="second-container">
          <div className="Hassection">
            <h1 className="text-center">🤵🏻</h1>
            <h3>About You</h3>
            <input
              type="text"
              name="yourFirstName"
              placeholder="Your first name"
              value={formData.yourFirstName}
              onChange={handleChange}
              className="input"
            />
            <input
              type="text"
              name="yourLastName"
              placeholder="Your last name"
              value={formData.yourLastName}
              onChange={handleChange}
              className="input"
            />
            <input
              type="text"
              name="yourNickname"
              placeholder="Your nickname"
              value={formData.yourNickname}
              onChange={handleChange}
              className="input"
            />
          </div>
          <div className="Hassection">
            <h1 className="text-center">👰🏻</h1>
            <h3>Your Partner</h3>
            <input
              type="text"
              name="partnerFirstName"
              placeholder="Partner's first name"
              value={formData.partnerFirstName}
              onChange={handleChange}
              className="input"
            />
            <input
              type="text"
              name="partnerLastName"
              placeholder="Partner's last name"
              value={formData.partnerLastName}
              onChange={handleChange}
              className="input"
            />
            <input
              type="text"
              name="partnerNickname"
              placeholder="Partner's nickname"
              value={formData.partnerNickname}
              onChange={handleChange}
              className="input"
            />
          </div>
        </div>

        <div className="Hassection">
          <h3>Wedding Details</h3>
          <input
            type="date"
            name="weddingDate"
            value={formData.weddingDate}
            onChange={handleChange}
            className="input"
          />
          <input
            type="text"
            name="weddingCity"
            placeholder="Wedding city"
            value={formData.weddingCity}
            onChange={handleChange}
            className="input"
          />
          <select
            name="weddingCategory"
            value={formData.weddingCategory}
            onChange={handleChange}
            className="input"
          >
            <option value="">Select Venue</option>
            <option value="Banquet Halls">Banquet Halls</option>
            <option value="Outdoor Venues">Outdoor Venues</option>
            <option value="Beach Weddings">Beach </option>
            <option value="Garden Weddings">Garden </option>
            <option value="Resort Weddings">Resort </option>
            <option value="Luxury Hotels">Luxury Hotels</option>
            <option value="Palace Weddings">Palace </option>
            <option value="Mountain View Venues">Mountain View Venues</option>
            <option value="Destination Weddings">Destination </option>
            <option value="Traditional Halls">Traditional Halls</option>
          </select>
        </div>
        <button type="submit" className="button">
          Generate Hashtags
        </button>
      </form>

      {hashtags.length > 0 && (
        <div className="tags">
          <h2> #Your Wedding Hashtags</h2>
          <ul className="hashtag-list">
            {hashtags
              .slice(startIndex, startIndex + hashtagsPerPage)
              .map((tag, index) => (
                <li
                  key={index}
                  className="pill"
                  onClick={() => copyToClipboard(tag)}
                >
                  {tag}
                </li>
              ))}
          </ul>

          <div className="button-container">
            <Button onClick={prevTags} disabled={startIndex === 0}>
              Previous
            </Button>
            <Button
              onClick={nextTags}
              disabled={startIndex + hashtagsPerPage >= hashtags.length}
            >
              Next
            </Button>
          </div>
        </div>
      )}
      
    </div></div>
  );
};

export default WeddingHashtagGenerator;
